import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import InlineRegionSelect from '../inputs/InlineRegionSelect';
import InlineSupplierSelect from '../inputs/InlineSupplierSelect';
import InlineInputNumber from '../inputs/InlineInputNumber';
import RuleForm from '../inputs/RuleForm';

class OrderSizeRule extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onReset = this.onReset.bind(this);
    const { initialValues } = props;
    this.initialState = {
      total: initialValues.total || 500000,
      supplier: initialValues.supplier || 'any',
      regions: initialValues.regions && initialValues.regions.length > 0 ? initialValues.regions : [0]
    };
    this.state = this.initialState;
  }

  onSubmit(event) {
    event.preventDefault();
    const value = _.omit(this.state, 'regions');
    this.props.onSubmit({
      kind: 'order_size',
      regions: _.filter(this.state.regions),
      value
    });
  }

  onReset() {
    this.setState(this.initialState);
  }

  render() {
    const { total, supplier, regions } = this.state;
    const { form, type, ...other } = this.props;

    return (
      <RuleForm
        {...other}
        onSubmit={this.onSubmit}
        onReset={this.onReset}
        isSubmitting={form.is_submitting}
      >
        <InlineRegionSelect
          onChange={val => this.setState({ regions: val })}
          value={regions}
        />
        <InlineSupplierSelect
          value={supplier}
          onChange={supplier_id => this.setState({ supplier: supplier_id })}
          include_all={false}
        />
        <InlineInputNumber
          label='Order Amount'
          description='Dollar value of a single order'
          displayFormat='dollar'
          value={total}
          onChange={value => this.setState({ total: value })}
        />
      </RuleForm>
    );
  }
}

OrderSizeRule.defaultProps = {
  type: 'add',
  initialValues: {}
};

OrderSizeRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default OrderSizeRule;
